import React from "react";
import { connect as connectFormik } from 'formik';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { withLocalize } from 'react-localize-redux';
import BbInput from '../styling/bbInput';
import MarketingSection from '../marketingList/marketingSection';
import SelectOption from './selectOption';
import { selectDefaultStyles } from '../styling/selectDefaultStyles';

class Vehicles extends React.Component {

    render() {
        return (<MarketingSection name={this.props.translate(this.props.label)} isOpen={this.props.isOpen || false} section="vehicles" field={this.props.field} searchTip={isNullOrUndefined(this.props.searchTip) ? null : this.props.translate(this.props.searchTip)
        } errors={this.props.errors} >
            {this.renderYesNo()}
            {this.renderHistory()}
        </MarketingSection>);
    }

    renderYesNo = () => {
        return (
            <BbInput type='radio' label={this.props.translate(this.props.label)} placeholder={{ type: 'column' }}
                options={[
                    { value: "1", label: 'Common.Yes.Lower' },
                    { value: "0", label: 'Common.No.Lower' }
                ]} idFormat={(val) => `$radio-${this.props.field}-hasItems-${val}`}
                checkedValue={this.getValue(this.props.formik.values[this.props.field].hasItems, "1")}
                callback={(val) => this.props.formik.setFieldValue(`${this.props.field}.hasItems`, val)}
            />
        );
    }

    renderHistory = () => {
        return (
            <BbInput type='select-noformik' label={this.props.translate('Report.Common.History')}
                placeholder={{ type: 'column' }}
                options={this.getYearOptions()} formatOptionLabel={SelectOption}
                onChange={(e) => this.props.formik.setFieldValue("vehicles.historyTo", e.value)}
                value={this.getYearOption(this.props.formik.values.vehicles.historyTo)}
                styles={selectDefaultStyles}
            />
        );
    }

    getValue(value, defaultValue) {
        return (isNullOrUndefined(value) || value === "") ? defaultValue : value;
    }

    getYearOption(year) {
        if (year === 1900)
            return { value: 1900, key: 1900, label: `${this.props.translate("Search.Marketing.Vehicles.OlderThan")} 2014` }
        else
            return { key: year, value: year, label: `${this.props.translate("Search.Marketing.Vehicles.NotOlderThan")} ${year}` };
    }

    getYearOptions() {
        let options = [];
        for (let i = new Date().getFullYear() - 1; i >= 2014; i--)
            options.push(this.getYearOption(i));
        options.push(this.getYearOption(1900));
        return options;
    }
}

export default withLocalize(connectFormik(Vehicles));